import dynamic from 'next/dynamic';
import { TDoccenLibraryDocumentFileSkeleton } from './type';

const DocumentFileGridViewType1Skeleton = dynamic(
  () => import('./skeletionVariants/DocumentFileGridViewType1')
);

const DocumentFileSkeleton = (props: TDoccenLibraryDocumentFileSkeleton) => {
  const hashVariants = {
    [`false_1`]: <></>,
    [`true_1`]: <DocumentFileGridViewType1Skeleton {...props} />,
    [`false_2`]: <></>,
    [`true_2`]: <></>, //havent had yet
  };

  return hashVariants[`${props.gridView}_${props.type}`];
};

export default DocumentFileSkeleton;
